module.exports = __webpack_public_path__ + "app/order-model/order-param/response-param-2RUdYRp0.html";